import $ from "jquery";
export default function tariffDetails() {
    $('.avu-additional-information-block .accordion-button').click(function() {
        let elementOffsetTop = $(".avu-additional-information-block .avu-themenblock-text-content").offset().top;
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        if (elementOffsetTop < viewportTop || elementOffsetTop > viewportBottom) {
            $("html, body").animate({
                scrollTop: elementOffsetTop
            }, 0);
        }
    });
    if ($('.tariff-booking-button-single').length > 0) {
        const items = [];
        const button = $('.tariff-booking-button-single');
        if (button.length > 0) {
            const tariffId = new URLSearchParams(window.location.search).get("tarif");
            const tariffName = button.data('tariff-name');
            const tariffVariant = button.data('tariff-variant');
            const tariffPrice = button.data('tariff-price');
            if (tariffId && tariffName && tariffVariant && tariffPrice) {
                items.push({
                    item_id: tariffId,
                    item_name: tariffName,
                    index: items.length + 1,
                    item_variant: tariffVariant,
                    price: tariffPrice
                });
            }
        }
        if (items.length > 0) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'view_item',
                items: items,
                currency: 'EUR',
                value: items[0].price
            });
        }
    }

}